export const isSafeHttpUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'https:';
  } catch {
    return false;
  }
};

export const getSafeRedirectUrl = ({ destination, fallback }: { destination?: string; fallback?: string }) => {
  const safeFallback = fallback && isSafeHttpUrl(fallback) ? fallback : undefined;

  if (destination && isSafeHttpUrl(destination)) {
    if (!safeFallback) {
      return destination;
    }

    const destinationUrl = new URL(destination);
    const fallbackUrl = new URL(safeFallback);

    if (destinationUrl.origin === fallbackUrl.origin) {
      return destination;
    }
  }

  return safeFallback;
};
